import dynamic from 'next/dynamic';
const StickyHeaderFooterCta = dynamic(() => import('./StickyHeaderFooterCta'));

export { StickyHeaderFooterCta };
